import { FC } from 'react'
import { BankDetailsRequest } from 'feature/company/types/BankDetails'
import { Button, TextField } from 'ui'

import styles from './BankDetailsPage.module.scss'

type BankDetailsFormProps = {
  form: BankDetailsRequest
  isAdding: boolean
  onChange: (field: keyof BankDetailsRequest, value: string) => void
  onNumericChange: (field: keyof BankDetailsRequest, value: string) => void
  onSubmit: () => void
  onCancel: () => void
}

const isDigitsValid = (value: string, length: number) =>
  value.length > 0 && !new RegExp(`^\\d{${length}}$`).test(value)

export const BankDetailsForm: FC<BankDetailsFormProps> = ({
  form,
  isAdding,
  onChange,
  onNumericChange,
  onSubmit,
  onCancel,
}) => {
  const isFormValid =
    form.bankName.trim() &&
    /^\d{9}$/.test(form.bik) &&
    /^\d{20}$/.test(form.correspondentAccount) &&
    /^\d{20}$/.test(form.currentAccount)

  return (
    <div className={styles.bankDetails__form} data-testid='bank-details-form'>
      <span className={styles.bankDetails__formTitle}>Новые реквизиты</span>
      <TextField
        label='Название банка'
        value={form.bankName}
        onChange={e => onChange('bankName', e.target.value)}
        required
        inputProps={{ maxLength: 128 }}
        data-testid='bank-details-input-bank-name'
      />
      <TextField
        label='БИК'
        value={form.bik}
        onChange={e => onNumericChange('bik', e.target.value)}
        required
        placeholder='9 цифр'
        inputProps={{ maxLength: 9 }}
        error={isDigitsValid(form.bik, 9)}
        helperText={
          isDigitsValid(form.bik, 9) ? 'БИК должен содержать 9 цифр' : ''
        }
        data-testid='bank-details-input-bik'
      />
      <TextField
        label='Корреспондентский счёт'
        value={form.correspondentAccount}
        onChange={e => onNumericChange('correspondentAccount', e.target.value)}
        required
        placeholder='20 цифр'
        inputProps={{ maxLength: 20 }}
        error={isDigitsValid(form.correspondentAccount, 20)}
        helperText={
          isDigitsValid(form.correspondentAccount, 20)
            ? 'Корреспондентский счёт должен содержать 20 цифр'
            : ''
        }
        data-testid='bank-details-input-correspondent'
      />
      <TextField
        label='Расчётный счёт'
        value={form.currentAccount}
        onChange={e => onNumericChange('currentAccount', e.target.value)}
        required
        placeholder='20 цифр'
        inputProps={{ maxLength: 20 }}
        error={isDigitsValid(form.currentAccount, 20)}
        helperText={
          isDigitsValid(form.currentAccount, 20)
            ? 'Расчётный счёт должен содержать 20 цифр'
            : ''
        }
        data-testid='bank-details-input-current'
      />
      <div className={styles.bankDetails__formActions}>
        <Button
          variant='contained'
          color='primary'
          onClick={onSubmit}
          disabled={!isFormValid || isAdding}
          data-testid='bank-details-submit'
        >
          Сохранить
        </Button>
        <Button
          variant='outlined'
          onClick={onCancel}
          data-testid='bank-details-cancel'
        >
          Отмена
        </Button>
      </div>
    </div>
  )
}
